/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Admin_Comments_SectionInputs */

const en_admin_external_booking_edit_admin_comments_section = /** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Comments (Internal)`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */
const de_admin_external_booking_edit_admin_comments_section = en_admin_external_booking_edit_admin_comments_section;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */
const es_admin_external_booking_edit_admin_comments_section = en_admin_external_booking_edit_admin_comments_section;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */
const fr_admin_external_booking_edit_admin_comments_section = en_admin_external_booking_edit_admin_comments_section;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */
const it_admin_external_booking_edit_admin_comments_section = en_admin_external_booking_edit_admin_comments_section;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_admin_comments_section = en_admin_external_booking_edit_admin_comments_section;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */
const pl_admin_external_booking_edit_admin_comments_section = en_admin_external_booking_edit_admin_comments_section;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */
const hu_admin_external_booking_edit_admin_comments_section = en_admin_external_booking_edit_admin_comments_section;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_SectionInputs) => LocalizedString} */
const ro_admin_external_booking_edit_admin_comments_section = en_admin_external_booking_edit_admin_comments_section;

/**
* | output |
* | --- |
* | "Admin Comments (Internal)" |
*
* @param {Admin_External_Booking_Edit_Admin_Comments_SectionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_admin_comments_section = /** @type {((inputs?: Admin_External_Booking_Edit_Admin_Comments_SectionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Admin_Comments_SectionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_admin_comments_section(inputs)
	if (locale === "de") return de_admin_external_booking_edit_admin_comments_section(inputs)
	if (locale === "es") return es_admin_external_booking_edit_admin_comments_section(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_admin_comments_section(inputs)
	if (locale === "it") return it_admin_external_booking_edit_admin_comments_section(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_admin_comments_section(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_admin_comments_section(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_admin_comments_section(inputs)
	return ro_admin_external_booking_edit_admin_comments_section(inputs)
});
export { admin_external_booking_edit_admin_comments_section as "admin.external_booking_edit.admin_comments_section" }